controllers.controller('FavoritesEditController', [
    '$scope', '$state', '$ionicLoading', '$injector', 'config', 'constants', 'FavoritesService', 'API', 'AssetService',
    function ($scope, $state, $ionicLoading, $injector, config, Const, FavoritesService, API, AssetService) {

        $scope.favorites = [];

        function getAssets() {
            var favorites = FavoritesService.getAll();

            function initFavorites(item) {
                var asset = AssetService.collection.get({id: item});
                return asset && $scope.favorites.push({id: item, name: asset.outputName});
            }

            if (favorites && AssetService.collection) {
                favorites.forEach(initFavorites);
            }
        }

        getAssets();

        function sync() {

            function toValues(key) {
                return _.toArray(_.mapValues($scope.favorites, key));
            }

            ($scope.favorites.length > 0) ?
                FavoritesService.sync(toValues('id')) :
                FavoritesService.clearAll();
        }

        $scope.moveItem = function (item, fromIndex, toIndex) {
            $scope.favorites.splice(fromIndex, 1);
            $scope.favorites.splice(toIndex, 0, item);
            sync();
        };

        $scope.removeItem = function (item) {
            var asset = AssetService.collection.get({id: item.id});
            asset.isFavorite = false;
            _.remove($scope.favorites, item);
            sync();
        };


        function clear() {
            $scope.favorites = [];
        }

        $scope.$on('$ionicView.afterLeave', clear);
        $scope.$on('clear', clear);

    }]);
